import {$controller} from "rapid/index";

const dependencies = ["$companies"];

export class SigninController extends $controller {

	constructor($injector) {
		"ngInject";
		super($injector, dependencies);
	}

	$redirect() {
		if (this.$auth.isAuthenticated()) {
			return this.$state.go("deployments");
		}
	}

	$onSubmit(formSignin) {
		return this.$auth
			.authenticate(this.user)
			.then((data) => {
				if (data && data.requires_2fa) {
					sessionStorage.setItem("2fa_email", this.user.email);
					sessionStorage.setItem("2fa_password", this.user.password);
					this.$state.go("auth.twoFactor");
					return;
				}
				return this.$companies.fetch().then(() => this.$redirect());
			})
			.finally(() => formSignin.$submitted = false);
	}

	$onInit(){
		this.$redirect();
	}

}



// WEBPACK FOOTER //
// ./sources/components/auth/signin/signin.controller.js